import { TheraApi } from '@thera-hr/api-sdk';

export type ReferralProfile = TheraApi.api.thera.referral.ReferralProfileResponse;
export type ReferralEvent = TheraApi.api.thera.referral.ReferralResponse;

export interface RedeemReferralPayload {
  slug: string;
  referredUserId?: string;
}

export interface AssociateReferralPayload {
  slug: string;
  userId: string;
}

export interface CompleteReferralPayload {
  userId: string;
  slug?: string;
}

export const getReferralProfile = (theraFernApi: any): Promise<ReferralProfile> => {
  return theraFernApi.thera.referral.referralApi.getProfile();
};

export const getReferrals = (theraFernApi: any): Promise<ReferralEvent[]> => {
  return theraFernApi.thera.referral.referralApi.getReferrals();
};

export const updateSlug = (
  theraFernApi: any,
  slug: string,
): Promise<TheraApi.api.thera.referral.SlugUpdateResponse> => {
  return theraFernApi.thera.referral.referralApi.updateSlug({ slug });
};

export const checkSlugAvailability = (
  theraFernApi: any,
  slug: string,
): Promise<TheraApi.api.thera.referral.SlugAvailabilityResponse> => {
  return theraFernApi.thera.referral.referralApi.checkSlugAvailability({ slug });
};

export const redeemReferralCode = async (theraFernApi: any, payload: RedeemReferralPayload): Promise<void> => {
  if (!payload.slug) return;
  await theraFernApi.thera.referral.referralApi.redeemReferral(payload);
};

export const associateReferral = async (theraFernApi: any, payload: AssociateReferralPayload): Promise<void> => {
  if (!payload.slug || !payload.userId) return;
  await theraFernApi.thera.referral.referralApi.associateReferral(payload);
};

export const completeReferral = async (theraFernApi: any, payload: CompleteReferralPayload): Promise<void> => {
  if (!payload.userId) return;
  await theraFernApi.thera.referral.referralApi.completeReferral(payload);
};

export const trackReferralClick = (theraFernApi: any, slug: string): void => {
  if (!slug) return;
  theraFernApi.thera.referral.referralApi.trackClick({ slug }).catch(() => undefined);
};

export const referralSignUp = async (
  theraFernApi: any,
  payload: TheraApi.api.thera.referral.ReferralSignUpRequest,
): Promise<ReferralProfile> => {
  return theraFernApi.thera.referral.referralApi.referralSignUp(payload);
};
